module.exports = __webpack_public_path__ + "img/interview_pic1.e86dad2c.png";